import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras, setExtra } from 'apps/auth/actions/extraAction';
import { changeFormFieldValue, removeFieldError } from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { PASSWORD } from 'apps/auth/constants/Constants';
import { LOGIN_REGISTRATION_FORM_NAME } from 'apps/auth/constants/formName';
import { RESTORE_PASSWORD } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const ExpiredPasswordInfoModal = (props) => {
    const { continueButton } = usePageMessages();

    const restorePassword = (e) => {
        e.preventDefault();
        apiFetchData(RESTORE_PASSWORD)
            .then((json) => {
                if (json) {
                    if (json.messages) {
                        props.updatePageMessages(json.messages);
                    }
                    props.removeFieldError(LOGIN_REGISTRATION_FORM_NAME, PASSWORD);
                    props.changeFormFieldValue(LOGIN_REGISTRATION_FORM_NAME, '', PASSWORD);
                    if (json.extra) {
                        props.addExtras(json.extra);
                    }
                }
                // props.setScreen(RESTORE_PASSWORD_SCREEN);
                props.popupRef.current?.close();
            })
            .catch(() => props.toggleSpinner(false));
    };

    return (
        <>
            <ModalComponent isVerticalCentered canCloseModal={false}>
                <InfoPage
                    insideModalComponent
                    animatedIconFail
                    mainText={props.mainText}
                    headerText={props.headerText}
                    primaryButtonCaption={continueButton}
                    primaryButtonType="button"
                    primaryButtonOnClick={restorePassword}
                    isTagA
                />
            </ModalComponent>
        </>
    );
};

export default connect(null, {
    toggleSpinner,
    updatePageMessages,
    setExtra,
    removeFieldError,
    changeFormFieldValue,
    addExtras,
})(ExpiredPasswordInfoModal);
